import React from "react";
import { siteConfig } from "../Datas/productData";
import PolicyNav, { POLICY_UPDATED } from "./PolicyNav";
import "../css/terms.scss";

function Terms() {
  const { contact } = siteConfig;

  return (
    <main className="policy-page terms">
      <header className="policy-hero policy-hero--legal">
        <p className="policy-eyebrow">Legal</p>
        <h1>Terms of service</h1>
        <p>
          The agreement that applies when you browse, order, or contact
          {` ${siteConfig.brandName}`} through this website.
        </p>
        <span>Effective {POLICY_UPDATED}</span>
      </header>

      <div className="policy-layout">
        <PolicyNav current="/terms" />

        <article className="policy-content policy-content--legal">
          <section className="policy-intro" aria-labelledby="terms-overview">
            <p className="policy-eyebrow">The agreement</p>
            <h2 id="terms-overview">Clear terms for a considered store.</h2>
            <p>
              This website and the {siteConfig.brandName} store are operated by
              {` ${contact.legalName}`}. By using the site, you agree to these
              Terms of Service and the policies linked here. If you do not agree,
              do not use the site.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-eligibility">
            <div className="policy-section__heading">
              <span>01</span>
              <h2 id="terms-eligibility">Eligibility &amp; customer details</h2>
            </div>
            <p>
              You must be legally capable of entering a binding contract in your
              jurisdiction, or use the store with the involvement of a parent or
              guardian. You agree to provide accurate, current contact, payment,
              and delivery information and to keep order communications secure.
              You are responsible for activity conducted using information or an
              account under your control.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-products">
            <div className="policy-section__heading">
              <span>02</span>
              <h2 id="terms-products">Products &amp; availability</h2>
            </div>
            <p>
              We try to present descriptions, dimensions, colors, materials,
              care instructions, pricing, and availability accurately. Displays
              and photography can show color differently, and handmade or
              material characteristics may create reasonable variation. We may
              correct errors, update information, limit quantities, or stop
              offering a product at any time.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-orders">
            <div className="policy-section__heading">
              <span>03</span>
              <h2 id="terms-orders">Orders &amp; acceptance</h2>
            </div>
            <p>
              Your checkout submission is an offer to buy. An automated receipt
              confirms that we received the request, not that it has been
              accepted. We may accept, reject, or cancel an order for reasonable
              grounds including unavailability, payment failure, an obvious
              price or description error, suspected fraud, purchase-limit abuse,
              or delivery restrictions. If we cancel after payment, we will
              return the affected amount to the original payment method.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-pricing">
            <div className="policy-section__heading">
              <span>04</span>
              <h2 id="terms-pricing">Prices, taxes &amp; payment</h2>
            </div>
            <p>
              Site prices are displayed in U.S. dollars unless stated otherwise.
              Shipping, applicable sales tax, and any other charge are shown
              before payment where we are responsible for collecting them.
              International import charges may be collected separately by the
              carrier or destination authority. Payment is handled by an
              independent hosted provider subject to its own terms. See our
              Payments &amp; Pricing Policy for more information.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-delivery">
            <div className="policy-section__heading">
              <span>05</span>
              <h2 id="terms-delivery">Shipping, title &amp; returns</h2>
            </div>
            <p>
              Processing and delivery times are estimates and may be affected by
              events outside our reasonable control. Responsibility for loss or
              damage transfers only as provided by applicable law and the agreed
              delivery terms. The Shipping &amp; Delivery Policy and Returns &amp;
              Refunds Policy form part of these terms.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-promotions">
            <div className="policy-section__heading">
              <span>06</span>
              <h2 id="terms-promotions">Promotions, discount codes &amp; gift cards</h2>
            </div>
            <p>
              A promotion may have additional terms, dates, eligible products,
              regions, or quantity limits. Unless stated otherwise, offers are
              not combinable, cannot be applied after purchase, have no cash
              value, and may end when stock is exhausted. We may reject a code
              obtained or used through fraud, automation, resale, or a breach of
              its terms. Gift-card rules shown at purchase also apply.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-use">
            <div className="policy-section__heading">
              <span>07</span>
              <h2 id="terms-use">Acceptable use</h2>
            </div>
            <p>You may use the site only for lawful personal or business purchasing purposes. You must not:</p>
            <ul>
              <li>interfere with the site, security, network, or another visitor;</li>
              <li>introduce malicious code or attempt unauthorized access;</li>
              <li>scrape, crawl, or automate access in a way that burdens the service;</li>
              <li>impersonate another person or submit false or unlawful information;</li>
              <li>use store content to mislead, infringe rights, or compete unlawfully; or</li>
              <li>circumvent purchase limits, access controls, or fraud checks.</li>
            </ul>
          </section>

          <section className="policy-section" aria-labelledby="terms-ip">
            <div className="policy-section__heading">
              <span>08</span>
              <h2 id="terms-ip">Intellectual property</h2>
            </div>
            <p>
              The site’s original text, photographs, graphics, branding,
              product presentation, software, and design are owned by or licensed
              to us and protected by applicable law. We grant you a limited,
              revocable, non-transferable right to access the site for its
              intended purpose. No other license is granted. Third-party names
              and marks belong to their respective owners.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-submissions">
            <div className="policy-section__heading">
              <span>09</span>
              <h2 id="terms-submissions">Reviews &amp; submissions</h2>
            </div>
            <p>
              If you voluntarily send a review, photograph, suggestion, or other
              content for publication, you confirm that you have the necessary
              rights and that it is accurate, lawful, and not misleading. You
              grant us a non-exclusive, worldwide, royalty-free license to host,
              reproduce, format, and display that content for store and product
              support purposes. We may moderate or remove submissions, but are
              not required to publish them.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-third-parties">
            <div className="policy-section__heading">
              <span>10</span>
              <h2 id="terms-third-parties">Third-party services</h2>
            </div>
            <p>
              Payment, delivery, and external links may be operated by independent
              providers. Their services, content, availability, and policies are
              their responsibility. A link or technical integration does not
              imply endorsement. Review the terms presented by a third party
              before using its service.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-disclaimers">
            <div className="policy-section__heading">
              <span>11</span>
              <h2 id="terms-disclaimers">Disclaimers &amp; limitation of liability</h2>
            </div>
            <p>
              To the fullest extent permitted by law, the site is provided “as
              is” and “as available,” without warranties not expressly stated.
              We do not guarantee uninterrupted or error-free access. To the
              fullest extent permitted by law, we are not liable for indirect,
              incidental, special, exemplary, or consequential loss arising from
              use of the site or a product. Our aggregate liability for a claim
              relating to an order will not exceed the amount paid for the
              product giving rise to that claim.
            </p>
            <p>
              These limits do not apply where prohibited, including to liability
              that cannot lawfully be limited or excluded. Nothing in these terms
              removes non-waivable consumer rights.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-indemnity">
            <div className="policy-section__heading">
              <span>12</span>
              <h2 id="terms-indemnity">Indemnity, suspension &amp; severability</h2>
            </div>
            <p>
              To the extent permitted by law, you agree to be responsible for
              third-party claims and reasonable costs caused by your unlawful use
              of the site, your content, or your material breach of these terms.
              We may suspend access needed to protect the store, customers, or
              others. If any provision is unenforceable, it will be narrowed or
              removed only as necessary and the remaining terms will continue.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-law">
            <div className="policy-section__heading">
              <span>13</span>
              <h2 id="terms-law">Governing law, changes &amp; contact</h2>
            </div>
            <p>
              These terms are governed by the laws of the State of Georgia,
              without regard to conflict-of-law rules, except where the mandatory
              law of your residence applies. Courts located in Chatham County,
              Georgia will have jurisdiction over disputes that may lawfully be
              submitted there.
            </p>
            <p>
              We may update these terms prospectively. The effective date above
              identifies the current version. The policies and order-specific
              terms referenced here form the entire agreement for your use of
              the store and do not create rights for a third party.
            </p>
            <p>
              Operator: {contact.legalName}, EIN {contact.ein},
              {` ${contact.address}`}. Questions may be sent to {contact.email}.
            </p>
          </section>

          <section className="policy-help" aria-labelledby="terms-help">
            <div>
              <p className="policy-eyebrow">Questions?</p>
              <h2 id="terms-help">Start a conversation with our team.</h2>
            </div>
            <a href={`mailto:${contact.email}`}>
              Contact us <span aria-hidden="true">↗</span>
            </a>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Terms;
